import React, { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../../css/channel-overview.scss";
import { fetchChannelOverview } from "../functions/fetchChannelOverview";
import translations from "../../text/get-started-translations.json";
import language from "../../utils/LanguageSettings";
import { ChannelButton } from "./ChannelOverview/ChannelItems";
import ChannelCategory from "./ChannelOverview/ChannelCategory";
import ChannelFilter from "./ChannelOverview/ChannelFilter";

const ChannelOverViewPage: React.FC = () => {
  const getInitialCategory = () => {
    if (window.myAppStrapi && window.myAppStrapi.urlHash) {
      return window.myAppStrapi.urlHash === "#on-demand" ? "on-demand" : "channel";
    }
    return window.location.hash === "#on-demand" ? "on-demand" : "channel";
  };

  const [channelGenres, setChannelGenres] = useState<string[]>([]);
  const [libraryGenres, setLibraryGenres] = useState<string[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [channelSelectedGenre, setChannelSelectedGenre] = useState<string>("all");
  const [librarySelectedGenre, setLibrarySelectedGenre] = useState<string>("all");
  const [selectedCategory, setSelectedCategory] = useState<string>(getInitialCategory());

  useEffect(() => {
    setSelectedCategory(getInitialCategory());
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchChannelOverview(language);

      if (response) {
        const channels = response.channels.map((channel: any) => ({
          ...channel,
          source: "channels",
        }));
        const libraries = response.libraries.map((library: any) => ({
          ...library,
          source: "libraries",
        }));
        const uniqueChannelGenres = Array.from(
          new Set([
            ...channels.flatMap((channel: any) => channel.attributes.ChannelOverview?.Genre),
          ])
        )
          .filter((genre) => genre) // Remove empty genres
          .sort(); // Sort genres alphabetically
        setChannelGenres(uniqueChannelGenres);
        const uniqueLibraryGenres = Array.from(
          new Set([
            ...libraries.flatMap((library: any) => library.attributes.ChannelOverview?.Genre),
          ])
        )
          .filter((genre) => genre) // Remove empty genres
          .sort(); // Sort genres alphabetically
        setLibraryGenres(uniqueLibraryGenres);
        setItems([...channels.filter((channel) => channel.attributes.ChannelOverview?.Genre), ...libraries.filter((library) => library.attributes.ChannelOverview?.Genre)]);
      }
    };
    fetchData();
  }, []);

  const resetAccordion = () => {
    const accordionElement = document.getElementById("accordionOverview");
    if (accordionElement) {
      const accordionItems = accordionElement.querySelectorAll(".accordion-item");
      accordionItems.forEach((item) => {
        const collapseElement = item.querySelector(".collapse");
        const buttonElement = item.querySelector(".channel");
        if (collapseElement) {
          collapseElement.classList.remove("show");
          collapseElement.setAttribute("aria-expanded", "false");
        }
        if (buttonElement) {
          buttonElement.classList.remove("active");
          buttonElement.setAttribute("aria-expanded", "false");
        }
      });
    }
  };

  const handleChannelGenreChange = useCallback((genre: string) => {
    setChannelSelectedGenre(genre);
    resetAccordion();
  }, []);

  const handleLibraryGenreChange = useCallback((genre: string) => {
    setLibrarySelectedGenre(genre);
    resetAccordion();
  }, []);

  const handleCategoryChange = useCallback((category: string) => {
    setSelectedCategory(category);
    resetAccordion();
  }, []);

  return (
    <>
      <div className="channel-list-wrapper">
        <div className="container">
          <ChannelCategory onCategoryChange={handleCategoryChange} />
        </div>
      </div>
      <div className="show-channels" id="channel">
        <div className="container">
          <div className="row">
            <div className="col">
              <ChannelFilter
                genres={selectedCategory === "on-demand" ? libraryGenres : channelGenres}
                selectedCategory={selectedCategory}
                channelSelectedGenre={channelSelectedGenre}
                librarySelectedGenre={librarySelectedGenre}
                onChannelGenreChange={handleChannelGenreChange}
                onLibraryGenreChange={handleLibraryGenreChange}
              />
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className="showchannel-list">
                <div className="channel-wrapper">
                  <div className="show_channels container-fluid">
                    <ChannelButton
                      items={items}
                      channelSelectedGenre={channelSelectedGenre}
                      librarySelectedGenre={librarySelectedGenre}
                      selectedCategory={selectedCategory}
                    />
                  </div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col">
                        <div className="accordion" id="accordionOverview"></div>
                      </div>
                    </div>
                  </div>
                  <div className="clear"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChannelOverViewPage;
